import type { PaymentTerms } from "../../convex/schemas/validators/quoteEnums";

interface CreditTermsPayment {
  netDays?: number;
  termsDays?: number;
  paymentTerms?: PaymentTerms;
  terms?: PaymentTerms;
}

export function isOnCreditTerms(payment: CreditTermsPayment | undefined): boolean {
  const termsDays = payment?.netDays ?? payment?.termsDays ?? 0;
  if (termsDays > 0) return true;
  return (payment?.paymentTerms ?? payment?.terms) === "payment_on_delivery";
}
